import { DataItem, getDataClass } from 'scrivito'

import { accumulateRecords } from './accumulateRecords'
import { accumulateUtilization } from './accumulateUtilization'
import { MyTeamEmployeeData } from '../../types'
import { DataClassName } from '@/Data/const'
import { ensureString } from '@/utils/ensureString'
import { getDataItem } from '@/utils/getDataItem'

export const buildEmployeeData = (
  userId: string,
  records: DataItem[],
  utilizationRecords: DataItem[],
): MyTeamEmployeeData | null => {
  const userDataItem = getDataItem(
    getDataClass(DataClassName.TIMERECORD_USER)!,
    userId,
  ).dataItem

  if (!userDataItem) return null

  const util = accumulateUtilization(utilizationRecords)
  const overallUtilization =
    util.totalWorkingTime > 0
      ? Math.round(
          (util.totalUtilizationWeighted * 100) / util.totalWorkingTime,
        )
      : 0
  const targetHours = util.totalWorkingTime
  const userName = ensureString(userDataItem.get('name'))

  const agg = accumulateRecords(records)

  return {
    userId,
    userName,
    userDataItem,
    totalHours: agg.totalHours,
    targetHours,
    dailyHours: agg.dailyHours,
    dailyRecordIds: agg.dailyRecordIds,
    dailyBillableStatus: agg.dailyBillableStatus,
    dailyBillableHours: agg.dailyBillableHours,
    dailyNonBillableHours: agg.dailyNonBillableHours,
    hasNonBillable: agg.hasNonBillable,
    isMissingHours: agg.totalHours < targetHours,
    billableHours: agg.billableHours,
    nonBillableHours: agg.nonBillableHours,
    supportHours: agg.supportHours,
    managedTeamHours: agg.managedTeamHours,
    notTrackedHours: Math.max(0, targetHours - agg.totalHours),
    utilization: overallUtilization,
    dailyUtilization: util.dailyUtilization,
    dailyAbsent: util.dailyAbsent,
  }
}
